import React from 'react'
import {Translate} from "react-redux-i18n";
import {Button, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import VerificationForm from "./VerificationForm";
import DisplayStatus from "./DisplayStatus";
import store from "../store";
import {submitPayment} from "../providers/providers";
import {validate} from "../lib/utils";

const I18n = require('react-redux-i18n').I18n;


const stateMap = (store) => {
    return {
        user: store.user
    };
};


class Payments extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            parsedJwt: null,
            authorizationCode: null,
            rawJwt: null,
            username: '',
            otp: '',
            usernameError: '',
            otpError: '',
        }

        Payments.parseJwt = Payments.parseJwt.bind(this)
        Payments.adjustAuthorizationCode = Payments.adjustAuthorizationCode.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange= this.handleChange.bind(this)
        this.handleAlert = this.handleAlert.bind(this)
        this.renderInstructions = this.renderInstructions.bind(this)
    }


    componentDidMount() {
        let param = this.props.location.search;
        let jwtData = param && param.trim() !== '' ? Payments.parseJwt(param) : null;
        let authorizationCode = jwtData && jwtData.creditorAccount && jwtData.instructedAmount ? Payments.adjustAuthorizationCode(jwtData.creditorAccount, jwtData.instructedAmount) : null ;
        this.setState({
            rawJwt: param && param.trim() !== '' && Payments.parseJwt(param) && param.includes('?details=') ? param.replace('?details=', '') : null,
            parsedJwt: jwtData,
            authorizationCode: authorizationCode
        })
    }

    handleAlert(show){
        this.setState({
            showError: show
        })
    }


    handleChange(event) {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        let validationResult = validate(this.state.username, this.state.otp);
        this.setState({
            usernameError: validationResult.usernameError,
            otpError: validationResult.otpError
        });
        if (!validationResult.isValid) return;
        store.dispatch(submitPayment(
            this.state.rawJwt,
            this.state.username,
            this.state.otp
            ))
            .then((response) => {
                if (this.state.parsedJwt !== null && this.state.parsedJwt.tppRedirectUri) {
                    window.location.replace(this.state.parsedJwt.tppRedirectUri)
                }
                this.props.history.push({
                    pathname: '/message',
                    search: '?type=success'
                })
            }, (error)=> {
                this.props.history.push({
                    pathname: '/message',
                    search: '?type=error'
                })
            })
    }

    renderInstructions() {
        let items = [];
        for (let i = 0; i < 8; i++) {
            items.push(
                i === 3 ?
                    <li key={i + "-instruction"}>
                        <Translate value={"payments.instructions.list" + (i + 1).toString()} paymentCode={this.state.authorizationCode} dangerousHTML/>
                    </li>
                   :  <li key ={i + "-instruction"}>
                        <Translate value={"payments.instructions.list" + (i + 1).toString()}/>
                      </li>
            );
        }
        return items;
    }


    static adjustAuthorizationCode(creditor, instructedAmount) {

        let amount = instructedAmount.amount
        let str = creditor.iban.slice(-3) + amount.replace(".", "").replace(",", "").slice(-3)
        if (str.length < 6) {
            let zero = "0";
            let zeroes = zero.repeat(6 - str.length);
            return str + zeroes;
        } else {
            return str;
        }
    }

    static parseJwt(token) {
        let base64Url = null;
        let base64 = null;
        let jsonPayload = null;
        try {
            base64Url = token.split('.')[1];
            base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        } catch (e) {
            jsonPayload = null;
        }
        return jsonPayload ? JSON.parse(jsonPayload) : null;
    }

    render() {
        let details = this.state.parsedJwt;
        let visualObj = details &&
        details.debtorAccount &&
        details.debtorAccount.iban &&
        details.creditorAccount &&
        details.creditorAccount.iban &&
        details.instructedAmount &&
        details.instructedAmount.currency &&
        details.instructedAmount.amount ? {
            debtorIban: details.debtorAccount.iban,
            creditorName: details.creditorName ? details.creditorName : '-',
            creditorIban: details.creditorAccount.iban,
            currency: details.instructedAmount.currency,
            amount: details.instructedAmount.amount
        } : undefined;

        if (details && visualObj && details.creditorAgent) {
            visualObj.creditorAgent = details.creditorAgent;
        }

        let prefix = "payments.fields.";
        return (
            <React.Fragment>
                {this.state.parsedJwt && this.state.authorizationCode && visualObj ?
                    <React.Fragment>
                        <Col className="payments__fields--wrapper" lg={{span: 6, offset: 3}}>
                            {Object.keys(visualObj).map((key, idx) => {
                                let label = prefix + key;
                                return <Row className="justify-content-md-center" key={key}>
                                    {idx === 0 ?
                                        <Col lg="10" className="payments-title">
                                            <h1>
                                                <Translate value="payments.title"/>
                                            </h1>
                                        </Col> : null
                                    }
                                    <Col lg="4" className="fields-lbl">
                                        <Translate value={label}/>
                                    </Col>
                                    <Col lg="6">
                                        {visualObj[key]}
                                    </Col>
                                </Row>

                                })}
                            </Col>
                            <Row className="justify-content-md-center">
                                <Col lg="8">
                                    <section className="payments-details">
                                        <Col lg="8" className="payments__user-instructions">
                                            <p>
                                                <Translate value={"payments.instructions.list"} />
                                            </p>
                                            <ul>
                                                {this.renderInstructions()}
                                            </ul>
                                        </Col>
                                        <Container className="payments-frm">
                                            <Row className="justify-content-md-center">
                                                <Col lg="8">
                                                    <Form onSubmit={this.handleSubmit}>
                                                        <VerificationForm
                                                            handleChange={this.handleChange}
                                                            username={this.state.username}
                                                            otp={this.state.otp}
                                                            usernameError={this.state.usernameError}
                                                            otpError={this.state.otpError} />
                                                            <Col>
                                                                <Row className="justify-content-md-end align-items-end">
                                                                    {this.props.user && this.props.user.entity.fetching ?
                                                                        <div className="lds-dual-ring"></div>: null}
                                                                    <Button variant="warning"
                                                                            className="cancel-btn"
                                                                            onClick={() => {
                                                                                this.props.history.push({
                                                                                    pathname: '/message',
                                                                                    search: '?type=cancel'
                                                                                })
                                                                            }}
                                                                    >
                                                                        <Translate value="button.cancel"/>
                                                                    </Button>
                                                                    <Button variant="info" type="submit" className="proceed-btn">
                                                                        <Translate value="button.proceed"/>
                                                                    </Button>
                                                                </Row>
                                                            </Col>
                                                            <Row>
                                                                <Col>
                                                                    {this.props.user && this.props.user.payment.fetching ?
                                                                        <Spinner animation="border" variant="info" className="bs-spinner spinner__custom-clr" />: null}
                                                                </Col>
                                                            </Row>
                                                            <DisplayStatus
                                                                statusMessage={this.state.loginError}
                                                                statusType={"error"}
                                                                showAlert={this.state.showError}
                                                                handleAlert={this.handleAlert}
                                                                dismissible={true}
                                                            />
                                                        </Form>
                                                 </Col>
                                             </Row>
                                        </Container>
                                    </section>
                                </Col>
                            </Row>
                        </React.Fragment>
                        :
                        <Row className="justify-content-md-center">
                            <Col lg="4" className="message-page">
                                <DisplayStatus
                                    statusMessage={I18n.t("messagePage.unknownError")}
                                    statusType={"error"}
                                    showAlert={true}
                                    dismissible={false}
                                />
                            </Col>
                        </Row>
                    }
            </React.Fragment>
        )
    }
}


export default withRouter(connect(stateMap)(Payments));

